// extracted by mini-css-extract-plugin
export default {"logo":"VerificationEmail_logo__niEwU"};